import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Stack from "@mui/material/Stack";
import { Box, IconButton } from "@mui/material";
import { LightTooltip } from "../../LightToolTip/LightToolTip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { KeyComponentProps } from "../../../pages/MyTracks/types";
import { ToggleButtonCustomized, styles } from "./styles";

const naturalKeys = ["C", "D", "E", "F", "G", "A", "B"];
const sharpKeys = ["C#", "D#", "F#", "G#", "A#"];
const flatKeys = ["Db", "Eb", "Gb", "Ab", "Bb"];

const KeyComponent: React.FC<KeyComponentProps> = ({
  songKey,
  scale,
  showKeyTooltip,
  setShowKeyTooltip,
  handleshowKeyTooltip,
  handleScale,
  handleKey,
}) => {
  // Function to generate toggle buttons dynamically
  const renderToggleButtons = (keys: string[], width = 50) =>
    keys.map((key) => (
      <ToggleButtonCustomized
        key={key}
        value={key}
        aria-label={key}
        style={{ width, textTransform: "none" }}
        disableRipple
      >
        {key.replace("#", "♯").replace("b", "♭")}
      </ToggleButtonCustomized>
    ));

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ marginBottom: 4, marginTop: 2 }}
    >
      {/* Label & Tooltip */}
      <label htmlFor="key" style={styles.stackLabel}>
        Key <span className="optional-input">(optional)</span>
        <Box
          style={{ display: "inline" }}
          onMouseOver={() => setShowKeyTooltip(true)}
          onMouseLeave={() => setShowKeyTooltip(false)}
        >
          <LightTooltip
            title="The key of a song is the note or chord the music is centered around"
            placement="top"
            open={showKeyTooltip}
            onClick={handleshowKeyTooltip}
          >
            <IconButton disableRipple>
              <HelpOutlineIcon color="info" style={{ height: 16, width: 16 }} />
            </IconButton>
          </LightTooltip>
        </Box>
      </label>

      {/* Key Selection Buttons */}
      <ToggleButtonGroup
        value={songKey}
        exclusive
        onChange={handleKey}
        aria-label="key"
      >
        {renderToggleButtons(naturalKeys)}
      </ToggleButtonGroup>

      <ToggleButtonGroup
        value={songKey}
        exclusive
        onChange={handleKey}
        aria-label="key sharp"
      >
        {renderToggleButtons(sharpKeys, 55)}
      </ToggleButtonGroup>

      <ToggleButtonGroup
        value={songKey}
        exclusive
        onChange={handleKey}
        aria-label="key flat"
      >
        {renderToggleButtons(flatKeys)}
      </ToggleButtonGroup>

      {/* Scale Selection Buttons */}
      <ToggleButtonGroup value={scale} exclusive onChange={handleScale}>
        {["minor", "major"].map((key) => (
          <ToggleButtonCustomized
            key={key}
            value={key}
            aria-label={key}
            style={styles.modalScale}
            disableRipple
          >
            {key.charAt(0).toUpperCase() + key.slice(1)}
          </ToggleButtonCustomized>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};

export default KeyComponent;
